export default {
  img: {
    height: '150px',
    width: '150px',
    margin: '10px 0 30px'
  },
  ref: {
    fontWeight: 'bold'
  }
}
